import { HttpClient, HttpContext } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { takeUntil, Subject } from 'rxjs';
import { GET_WEBHOOK_PAYMENT, RESEND_WEBHOOK } from 'src/app/constants/endpoint.const';
import * as requestPayloadData from 'src/app/constants/request-payload.json';
import * as responsePayloadData from 'src/app/constants/response-payload.json';
import { BypassInterceptorContext } from 'src/app/interceptors/http.interceptor';
import { BaseService } from 'src/app/services/base.service';

@Component({
  selector: 'app-webhook-detail',
  standalone: false,
  templateUrl: './webhook-detail.component.html',
  styleUrl: './webhook-detail.component.scss'
})
export class WebhookDetailComponent {
  private destroy$ = new Subject<void>();
  loading = true;
  requestPayload: string;
  rawJsonData: any;

  responsePayload: string;
  rawJsonDataResponse: any;

  paymentID: string = '';
  isResponsePanelActive: boolean = true;
  dataWebhook: any;

  constructor(
    private route: Router,
    private baseService: BaseService,
    private activeRoute: ActivatedRoute,
    private http: HttpClient,
    private messageService: NzMessageService
  ) {
    this.rawJsonData = (requestPayloadData as any).default || requestPayloadData;
    this.requestPayload = '```json\n' + JSON.stringify(this.rawJsonData, null, 2) + '\n```';

    this.rawJsonDataResponse = (responsePayloadData as any).default || responsePayloadData;
    this.responsePayload = '```json\n' + JSON.stringify(this.rawJsonDataResponse, null, 2) + '\n```';
  }

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params: any) => {
      this.paymentID = params.id;
    });
    this.getDetailWebhook(this.paymentID);
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  back() {
    this.route.navigate(['webhook']);
  }

  onCopyToClipboard(data: any) {
    let payload = data;
    if (typeof data === 'string') {
      try {
        payload = JSON.parse(data);
      } catch (e) {
        console.error(e);
      }
    }
    const jsonString = JSON.stringify(payload, null, 2);
    this.copyToClipboard(jsonString);
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.messageService.success('Copy to clipboard');
  }

  getDetailWebhook(id: string) {
    this.baseService.getData(GET_WEBHOOK_PAYMENT + '/' + id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.dataWebhook = res.data;
        let payload = this.dataWebhook.payload;
        let response = this.dataWebhook.response_payload;
        if (typeof payload === 'string') {
          try {
            payload = JSON.parse(payload);
          } catch (e) {
            console.error(e);
          }
        }
        if (typeof response === 'string') {
          try {
            response = JSON.parse(response);
          } catch (e) {
            console.error(e);
          }
        }
        this.requestPayload = '```json\n' + JSON.stringify(payload, null, 2) + '\n```';
        this.responsePayload = '```json\n' + JSON.stringify(response, null, 2) + '\n```';
      });
  }

  onResend(item: any): void {
    item.status_code = 'pending';
    const params = {
      payment_id: item.payment_id
    }
    this.baseService.postData(RESEND_WEBHOOK, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          this.getDetailWebhook(this.paymentID);
          this.messageService.success('Resend successfully');
        },
        error: (err: any) => {
          this.loading = false;
          this.getDetailWebhook(this.paymentID);
          this.messageService.error('Resend failed');
        }
      });
  }

  getStatusClass(value: string | number) {
    switch (value) {
      case 'success':
        return 'status-success';
      case 'failed':
        return 'status-danger';
      case 'pending':
        return 'status-warning';
      case 200:
        return 'status-success';
      case 400:
        return 'status-danger';
      case 404:
        return 'status-warning';
      default:
        return 'status-default';
    }
  }
  getStatusValue(value: string | number) {
    switch (value) {
      case 'success':
        return 'Success';
      case 'failed':
        return 'Failed';
      case 'pending':
        return 'Pending';
      case 200:
        return 'Success';
      case 400:
        return 'Failed';
      case 404:
        return 'Pending';
      default:
        return 'Pending';
    }
  }

  getPaymentValue(value: string) {
    switch (value) {
      case 'bank_transfer':
        return 'Bank Transfer';
      case 'qris':
        return 'QRIS';
      case 'va':
        return 'VA';
      default:
        return value;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
